/*
 * Add-to-bag state machine for product cards (.ll-product-card__add).
 * Delegated from document so it covers every section rendering the card.
 *
 * States: idle -> loading -> success ("Added. View bag") -> idle after 5s.
 * Success-state click opens the bag drawer via the existing data-bag-trigger
 * flow. Cards carrying data-max stop at the stock on hand, counting what is
 * already in the bag, so the shopper never reaches checkout with a line the
 * shop cannot fulfil.
 */
(function () {
  var IDLE_LABEL = 'Add to bag';
  var LOADING_LABEL = 'Adding...';
  var SUCCESS_LABEL = 'Added. View bag';
  var MAX_LABEL = 'All in your bag';
  var SUCCESS_TIMEOUT_MS = 5000;

  var timers = new WeakMap();

  function setState(btn, next) {
    btn.dataset.state = next;
    if (next === 'idle') {
      btn.textContent = IDLE_LABEL;
      btn.disabled = false;
    } else if (next === 'loading') {
      btn.textContent = LOADING_LABEL;
      btn.disabled = true;
    } else if (next === 'success') {
      btn.textContent = SUCCESS_LABEL;
      btn.disabled = false;
    } else if (next === 'max') {
      /* Not disabled: it reads as a link into the bag, where the shopper can
         remove the line if they want to change their mind */
      btn.textContent = MAX_LABEL;
      btn.disabled = false;
    }
  }

  function scheduleRevert(btn) {
    var existing = timers.get(btn);
    if (existing) clearTimeout(existing);
    var t = setTimeout(function () {
      timers.delete(btn);
      if (btn.dataset.state !== 'success') return;
      setState(btn, 'idle');
      evaluate(btn);
    }, SUCCESS_TIMEOUT_MS);
    timers.set(btn, t);
  }

  function openDrawer() {
    var trigger = document.querySelector('[data-bag-trigger]');
    if (trigger) trigger.click();
  }

  function maxFor(btn) {
    if (!btn.dataset.max) return null;
    var max = parseInt(btn.dataset.max, 10);
    return isNaN(max) ? null : max;
  }

  /* Mark a card as maxed out when the bag already holds all the stock there is */
  function evaluate(btn) {
    var max = maxFor(btn);
    if (max === null || !window.llCart) return Promise.resolve(false);
    if (btn.dataset.state === 'loading' || btn.dataset.state === 'success') {
      return Promise.resolve(false);
    }

    return window.llCart.quantityFor(btn.dataset.variantId).then(function (quantity) {
      var maxed = quantity >= max;
      if (maxed) {
        setState(btn, 'max');
      } else if (btn.dataset.state === 'max') {
        setState(btn, 'idle');
      }
      return maxed;
    });
  }

  function evaluateAll() {
    document.querySelectorAll('.ll-product-card__add[data-max]').forEach(evaluate);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ll-product-card__add');
    if (!btn) return;
    e.preventDefault();

    if (btn.dataset.state === 'success' || btn.dataset.state === 'max') {
      openDrawer();
      return;
    }
    if (btn.dataset.state === 'loading') return;

    var variantId = btn.dataset.variantId;
    if (!variantId || !window.llCart) return;

    evaluate(btn)
      .then(function (maxed) {
        if (maxed) return null;
        setState(btn, 'loading');
        return window.llCart.add({ id: parseInt(variantId, 10), quantity: 1 });
      })
      .then(function (result) {
        if (!result) return;
        setState(btn, 'success');
        scheduleRevert(btn);
        openDrawer();
      })
      .catch(function (err) {
        /* 422 means Shopify refused the line, in practice always on stock */
        if (err && err.rejected) {
          setState(btn, 'max');
        } else {
          setState(btn, 'idle');
        }
      });
  });

  document.addEventListener('cart:updated', evaluateAll);
  evaluateAll();
})();
